import HorizontalLayout from 'Container/HorizontalLayout'
import Full from 'Container/Full'

import auth from '../middleware/auth';

// Router
const Dashboard = () => import('Views/Dashboard');

const Bids = () => import('Views/Bids');
const Comments = () => import('Views/Comments');

const Banks = () => import('Views/finance/Banks');
const ExpenseCodes = () => import('Views/finance/ExpenseCodes');
const ExpenseRecords = () => import('Views/finance/ExpenseRecords');
const Transactions = () => import('Views/finance/Transactions');
const Invoices = () => import('Views/finance/Invoices');
const Payments = () => import('Views/finance/Payments');
const FailedPayments = () => import('Views/finance/FailedPayments');
const EftReports = () => import('Views/finance/EftReports');
const DebtList = () => import('Views/finance/DebtList');

const Chat = () => import('Views/chat/Chat');

const UsersPending = () => import('Views/users/Pending');
const UsersPendingAbout = () => import('Views/users/AboutPending');
const UsersNormal = () => import('Views/users/Normal');
const UsersCompany = () => import('Views/users/Company');
const UsersTransporter = () => import('Views/users/Transporter');
const UsersMissingDocuments = () => import('Views/users/MissingDocuments');
const UsersEdit = () => import('Views/users/Edit');
const UsersBlock = () => import('Views/users/Blocks');

const PagesHelps = () => import('Views/pages/Helps');

const PagesBlogs = () => import('Views/pages/Blogs');
const PagesPage = () => import('Views/pages/Pages');


export default {
  path: '/',
  component: Full,
  redirect: '/default/dashboard',
  children: [
    {
      path: '/default/dashboard',
      component: Dashboard,
      name: 'dashboard',
      meta: {
        middleware: auth,
        title: 'Dashboard / Tasin',
        breadcrumb: 'Dashboard / Tasin'
      }
    },
    {
      path: '/default/bids',
      component: Bids,
      name: 'bids',
      meta: {
        middleware: auth,
        title: 'Aktif Ihaleler',
        breadcrumb: 'Ihaleler / Aktif'
      }
    },
    {
      path: '/default/comments',
      component: Comments,
      name: 'comments',
      meta: {
        middleware: auth,
        title: 'Yorumlar',
        breadcrumb: 'Ihaleler / Yorumlar'
      }
    },
    {
      path: '/default/finance/banks',
      component: Banks,
      name: 'finance.banks',
      meta: {
        middleware: auth,
        title: 'Bankalar',
        breadcrumb: 'Finans / Bankalar'
      }
    },
    {
      path: '/default/finance/expenseCodes',
      component: ExpenseCodes,
      name: 'finance.codes',
      meta: {
        middleware: auth,
        title: 'Masraf Kodları',
        breadcrumb: 'Finans / Masraf Kodları'
      }
    },
    {
      path: '/default/finance/expenseRecords',
      component: ExpenseRecords,
      name: 'finance.exrecords',
      meta: {
        middleware: auth,
        title: 'Hesap Hareketleri',
        breadcrumb: 'Finans / Masraf Kayitlari'
      }
    },
    {
      path: '/default/finance/transactions',
      component: Transactions,
      name: 'finance.transactions',
      meta: {
        middleware: auth,
        title: 'Hesap Hareketleri',
        breadcrumb: 'Finans / Hesap Hareketleri'
      }
    },
    {
      path: '/default/finance/invoices',
      component: Invoices,
      name: 'finance.invoices',
      meta: {
        middleware: auth,
        title: 'Faturalar',
        breadcrumb: 'Finans / Faturalar'
      }
    },
    {
      path: '/default/finance/eft-reports',
      component: EftReports,
      name: 'finance.eftreports',
      meta: {
        middleware: auth,
        title: 'EFT Raporlar',
        breadcrumb: 'Finans / EFT Raporlari'
      }
    },
    {
      path: '/default/finance/payments',
      component: Payments,
      name: 'finance.invoices',
      meta: {
        middleware: auth,
        title: 'Kredi Karti Ödemeleri',
        breadcrumb: 'Finans / Kredi Karti Ödemeleri'
      }
    },
    {
      path: '/default/finance/failedPayments',
      component: FailedPayments,
      name: 'finance.failedpayments',
      meta: {
        middleware: auth,
        title: 'Hatalı Ödemeler',
        breadcrumb: 'Finans / Hatalı Ödemeler'
      }
    },
    {
      path: '/default/finance/debtList',
      component: DebtList,
      name: 'finance.debtlist',
      meta: {
        middleware: auth,
        title: 'Borcu Listesi',
        breadcrumb: 'Finans / Borcu Listesi'
      }
    },
    {
      path: '/default/support/index',
      component: Chat,
      name: 'support.index',
      meta: {
        middleware: auth,
        title: 'Destek',
        breadcrumb: 'Destek / Canli Destek'
      }
    },
    {
      path: '/default/users/normal',
      component: UsersNormal,
      name: 'users.normal',
      meta: {
        middleware: auth,
        title: 'Kullanıcılar',
        breadcrumb: 'Kullanıcılar / Normal'
      }
    },
    {
      path: '/default/users/pending',
      component: UsersPending,
      name: 'users.pending',
      meta: {
        middleware: auth,
        title: 'Kullanıcılar',
        breadcrumb: 'Kullanıcılar / Onay Bekleyenler'
      }
    },
    {
      path: '/default/users/pending-about',
      component: UsersPendingAbout,
      name: 'users.pendingabout',
      meta: {
        middleware: auth,
        title: 'Kullanıcılar',
        breadcrumb: 'Kullanıcılar / Hakkinda Onayi Bekleyenler'
      }
    },
    {
      path: '/default/users/company',
      component: UsersCompany,
      name: 'users.company',
      meta: {
        middleware: auth,
        title: 'Kullanıcılar',
        breadcrumb: 'Kullanıcılar / Şirket'
      }
    },
    {
      path: '/default/users/transporter',
      component: UsersTransporter,
      name: 'users.transporter',
      meta: {
        middleware: auth,
        title: 'Kullanıcılar',
        breadcrumb: 'Kullanıcılar / Taşıyıcı Firma'
      }
    },
    {
      path: '/default/users/edit/:id',
      component: UsersEdit,
      name: 'users.edit',
      meta: {
        middleware: auth,
        title: 'Kullanıcılar',
        breadcrumb: 'Kullanıcılar / Düzenle'
      }
    },
    {
      path: '/default/users/blocked',
      component: UsersBlock,
      name: 'users.blocked',
      meta: {
        middleware: auth,
        title: 'Kullanıcılar',
        breadcrumb: 'Kullanıcılar / Yasaklananlar'
      }
    },
    {
      path: '/default/users/missingDocuments',
      component: UsersMissingDocuments,
      name: 'users.missingDocuments',
      meta: {
        middleware: auth,
        title: 'Eksik Evraklar',
        breadcrumb: 'Kullanıcılar / Eksik Evraklar'
      }
    },
    {
      path: '/default/pages/helps',
      component: PagesHelps,
      name: 'pages.helps',
      meta: {
        middleware: auth,
        title: 'Yardım Sayfaları',
        breadcrumb: 'Sayfalar / Yardım'
      }
    },
    {
      path: '/default/pages/blogs',
      component: PagesBlogs,
      name: 'pages.helps',
      meta: {
        middleware: auth,
        title: 'Blog Sayfaları',
        breadcrumb: 'Sayfalar / Blog'
      }
    },
    {
      path: '/default/pages/page',
      component: PagesPage,
      name: 'pages.page',
      meta: {
        middleware: auth,
        title: 'Kurumsal Sayfalar',
        breadcrumb: 'Sayfalar / Kurumsal'
      }
    }
  ]
}
